// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"EditCommPageHeader_headerContainer__1ZLN9","commLabel":"EditCommPageHeader_commLabel__2AQ7E"};